/**
 *
 * TnCPage
 *
 */
import { Box, Button, Link, Typography } from '@mui/joy';
import * as React from 'react';
import styled from 'styled-components/macro';
import { PRIVACY_POLICY_ROUTE, TNC_ROUTE } from 'app/constants/route';

import { useNavigate } from 'react-router-dom';

interface Props { }

export function TnCPage(props: Props) {
  return (
    <Box
      sx={{
        // height: '100vh',
        scrollSnapType: 'y mandatory',
        '& > div': {
          scrollSnapAlign: 'start',
        },
      }}
    >

      <TermsAndConditions></TermsAndConditions>
    </Box>
  );
}
const TermsAndConditions = () => {
  const navigate = useNavigate();
  return (
    <Box sx={{ my: 4, mb: 6, mx: 6 }}>
      <Typography level="title-lg" mb={2} textAlign={'center'}>
        TERMS AND CONDITIONS
      </Typography>

      <ol>
        <li>
          <Typography level="body-md">Introduction</Typography>
          <Typography level="body-sm">
            These Terms and Conditions ("Terms") govern your access to and use
            of our math exercise generation service (the "Service") provided by
            AcademIX Ltd. ("we", "us", or "our"). By using the Service, you
            acknowledge that you have read, understood, and agreed to be bound
            by these Terms.
          </Typography>
        </li>
        <Box sx={{ m: 2 }}></Box>
        <li>
          <Typography level="body-md">Use of the Tool</Typography>
          <Typography level="body-sm">
            The Service is intended for personal, non-commercial use only. You
            may not reproduce, distribute, modify, display, sell, or transmit
            any part of the Service without prior written consent from us.
          </Typography>
        </li>

        <Box sx={{ m: 2 }}></Box>
        <li>
          <Typography level="body-md">Limitation of Liability</Typography>
          <Typography level="body-sm">
            The math exercises generated by our tool are for practice and
            assessment purposes only. We do not guarantee that they will
            accurately assess a student's mastery of specific math concepts or
            skills, and they should not be relied upon as the sole basis for
            evaluating student progress or making decisions related to
            instructions. You acknowledge that the exercises are subject to
            change without notice, and we cannot guarantee that they will remain
            aligned with curriculum standards or educational goals.
          </Typography>
        </li>

        <Box sx={{ m: 2 }}></Box>
        <li>
          <Typography level="body-md">Data Sources</Typography>
          <Typography level="body-sm">
            The exercises are generated based on algorithms and data sources
            that may or may not reflect real-world scenarios. The data used in
            the Service is subject to change without notice, and we do not
            guarantee that it will remain accurate or up-to-date. You
            acknowledge that the data used in the Service may be incomplete,
            outdated, or inaccurate, and you should exercise caution when
            relying on the exercises generated by the Service.
          </Typography>
        </li>

        <Box sx={{ m: 2 }}></Box>
        <li>
          <Typography level="body-md">
            Content Generation and No Warranty
          </Typography>
          <Typography level="body-sm">
            The math exercises generated by our Service are created using
            artificial intelligence (AI) algorithms and machine learning models.
            While we strive to ensure the accuracy and quality of the exercises,
            we acknowledge that AI-generated content may contain errors,
            inaccuracies, or biases. Although we have spent a significant amount
            of time auditing and reviewing the correctness of our AI-generated
            content, we cannot guarantee its perfection. You understand and
            agree that the use of AI-generated content is subject to certain
            limitations and risks, including but not limited to errors or
            inaccuracies in the exercises, biases or unfairness in the
            assessment of student performance, and limited contextual
            understanding or relevance to real-world scenarios. We disclaim any
            liability for damages or losses arising from the use of our Service,
            including those related to the accuracy, completeness, or
            reliability of the AI-generated content. You acknowledge that you
            are responsible for reviewing and verifying the exercises generated
            by our Service before using them in an instructional setting.
            Furthermore, we disclaim all warranties, express or implied,
            regarding the accuracy, completeness, or reliability of the
            exercises generated by the Service. You use the Service at your own
            risk, and we shall not be liable for any damages or losses arising
            from its use.
          </Typography>
        </li>
        <Box sx={{ m: 2 }}></Box>

        <li>
          <Typography level="body-md">Indemnification</Typography>
          <Typography level="body-sm">
            You agree to indemnify and hold us harmless from any claims,
            demands, or actions arising from your use of the Service or your
            reliance on the exercises generated by it. This includes, but is not
            limited to, claims related to alleged inaccuracies, incompleteness,
            or unreliability of the exercises.
          </Typography>
        </li>
        <Box sx={{ m: 2 }}></Box>

        <li>
          <Typography level="body-md">Intellectual Property</Typography>
          <Typography level="body-sm">
            The Service, including its content, design, and functionality, is
            owned by AcademIX Ltd. and protected by intellectual property laws.
            You may not copy, reproduce, or distribute any part of the Tool
            without prior written consent from us.
          </Typography>
        </li>

        <Box sx={{ m: 2 }}></Box>
        <li>
          <Typography level="body-md">Privacy Policy</Typography>
          <Typography level="body-sm">
            By using the Tool, you consent to the collection and use of your
            data as described in our privacy policy, which can be found
            <Link
              variant="plain"
              onClick={() => {
                navigate(PRIVACY_POLICY_ROUTE);
              }}
            >
              here.
            </Link>
          </Typography>
        </li>

        <Box sx={{ m: 2 }}></Box>
        <li>
          <Typography level="body-md">Termination</Typography>
          <Typography level="body-sm">
            We may terminate your access to the Service at any time without
            notice if you fail to comply with these Terms. Upon termination, you
            must destroy all copies of the Service and any data generated by it.
          </Typography>
        </li>

        <Box sx={{ m: 2 }}></Box>
        <li>
          <Typography level="body-md">Force Majeure</Typography>
          <Typography level="body-sm">
            We shall not be liable for failure to perform obligations under
            these Terms due to circumstances beyond our control, such as natural
            disasters or third-party service interruptions.
          </Typography>
        </li>
        <Box sx={{ m: 2 }}></Box>

        <li>
          <Typography level="body-md">Effective Date and Updates</Typography>
          <Typography level="body-sm">
            These Terms are effective as of 15th July, 2024 and may be updated
            at any time without notice. Continued use of the Service constitutes
            acceptance of such updates.
          </Typography>
        </li>
      </ol>

      <Typography level="body-md" mt={2}>
        By using the Tool, you acknowledge that you have read, understood, and
        agreed to be bound by these Terms.
      </Typography>
    </Box>
  );
};
const Div = styled.div``;
